import { render, staticRenderFns } from "./users.vue?vue&type=template&id=2460af2a&scoped=true"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"
import style0 from "./users.vue?vue&type=style&index=0&id=2460af2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460af2a",
  null
  
)

export default component.exports